import { css } from "@vitality-ds/system";

// Adjust alignment of inline text with the icon
export default css({
  display: "flex",
  variants: {
    topNudge: {
      "default": {
        marginTop: "0.25rem"
      },
      blockCompact: {
        marginTop: "0.15rem"
      },
      compact: {}
    }
  }
});